<template>
  <div></div>
</template>

<script>

export default {
  name: 'Wizard',
  components: {
  },
  data() {
    return {
      blogsInfo: [],
      loading: true

    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
  }
}

</script>

<style lang="scss" scoped>

</style>
